<template>
    <div class="content">
        <div class="row text-left px-md-5">
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">LOCATION </span>
                <span class="d-block">RevolutionPlus House. No 1 Olufunmilola Okikiolu </span>
                <span class="d-block">Street, Off Toyin Street Ikeja Lagos.</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">PHONE</span>
                <span class="d-block">08036938554, 09060000991</span>
                <span class="d-block">09060000992, 09060000993.</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">E-MAIL</span>
                <span class="d-block">info@revolutionplusproperty.com</span>
            </div>
        </div>
        <hr />
        <div class="row address-info text-left">
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">IKEJA OFFICE: </span>
                <span class="d-block">RevolutionPlus House 1, Olufunmilola Okikiolu Street, </span>
                <span class="d-block">Off Toyin Street Ikeja Lagos.</span>
                <span class="d-block">+234 803 693 8554</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">LEKKI OFFICE: </span>
                <span class="d-block">41, Freedom Way, Beside</span>
                <span class="d-block">Stanbic IBTC Bank, By Ikate</span>
                <span class="d-block">Round-About, Lekki Phase 1,</span>
                <span class="d-block">Lekki ,Lagos.</span>
                <span class="d-block">+234 908 678 7259 +234 814 387 8574</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">IBADAN OFFICE: </span>
                <span class="d-block">26, Ring Road, Old Nepa</span>
                <span class="d-block">Bus Stop Iyana Anfani, </span>
                <span class="d-block">Challenge, Ibadan. </span>
                <span class="d-block">+234 805 342 4485</span>
                <span class="d-block">+234 805 342 4486</span>
                <span class="d-block">+234 805 342 4489</span>
            </div>
        </div>
        <hr />
        <div class="row address-info text-left">
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">ABUJA OFFICE: </span>
                <span class="d-block">Suite 6, Autan Mama Plaza, 2, Sakono</span>
                <span class="d-block">Street Opp. AP Plaza, Wuse 2, Abuja.</span>
                <span class="d-block">+234 818 009 2608</span>
                <span class="d-block">+234 903 170 5796</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">DALLAS, TEXAS OFFICE: </span>
                <span class="d-block">9304 Forest Lane Suit S207,</span>
                <span class="d-block">Dallas Texas 75243 </span>
                <span class="d-block">(+1) 6824148457</span>
                <span class="d-block">(+1) 2143821564</span>
                <span class="d-block">info@revolutionplusproperty.com</span>
            </div>
            <div class="col-md-4">
                <span class="font-bold d-block heading-text">SALES HOTLINES: </span>
                <span class="d-block">+234 906 000 0991</span>
                <span class="d-block">+234 906 000 0992</span>
                <span class="d-block">+234 906 000 0993</span>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: "ContactFooter",
    computed: {
        currentYear() {
            return new Date().getFullYear()   
        }
    }
}
</script>

<style scoped>
.content {
    border-radius: 7px;
    margin: 30px 0;
    background: #909090;
    color: #fff;
    padding: 20px;
}
@media (min-width: 1200px) {
    .content {
        padding: 40px 70px;
    }
    .address-info {
        padding-left: 10%;
        padding-right: 10%;
    }
}
.heading-text {
    margin-bottom: 5px;
}
hr {
    border-top: 1px solid #fff;
    margin: 25px 0;
}
</style>